module.exports = __webpack_public_path__ + "static/media/ports.e854c14f.svg";